import { BaseModel } from '../../base.model';

export class ManPowerSubRequirementDto extends BaseModel {
  ManPowerSubRequirementID: string;
  ManPowerRequirementID: string;
  JobID: string | null;
  PlantID: number | null;
  bActive: boolean;
  Name: string;
  RequirementName: string;
  bMandatory: boolean;
  SafetyCouncilID: string | null;
  SafetyCouncilName: string | null;
  bBillable: boolean;
  bAddToSafetyTime: boolean;
  VPTrainingClassKeyID: number;
  CourseLength: number | null;
  ManPowerSubRequirementGroupID: string;
  GroupName: string;
  Notes: string | null;
  DateModified: string;
  ModifiedBy: string;

  RequestedClasses: ManPowerSubRequirementRequestedClass[];

  constructor(o: any = null) {
    super(o);
  }
}

export interface ManPowerSubRequirementRequestedClass {
  ManPowerSubRequirementRequestedClassID?: string;
  ManPowerSubRequirementID?: string;
  RequestedTradeClassID?: string;
  RequestedLinkedClassID?: string;
  RequestedClassName?: string;
  bActive: boolean;
}
